import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { toggleOwnershipSection } from './actions'
import { openLinkagesById } from '../../../../../Linkages/actions'

export function mapStateToProps(state, props) {
    const { mainId } = props

    return {
        toggledSections: state.getIn(
            ['ui', 'workspace', 'report', mainId, 'blocks', 'ownership', 'customData', 'toggledSections'],
            null
        ),
    }
}

export function mapDispatchToProps(dispatch) {
    return bindActionCreators({ toggleOwnershipSection, openLinkagesById }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
